/* unplugin-vue-components disabled */import { render } from "./navbar-list.vue?vue&type=template&id=b3238e68&scoped=true"
import script from "./navbar-list.vue?vue&type=script&lang=js"
export * from "./navbar-list.vue?vue&type=script&lang=js"

import "./navbar-list.vue?vue&type=style&index=0&id=b3238e68&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3238e68"],['__file',"src/components/navbar/navbar-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b3238e68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b3238e68', __exports__)) {
    api.reload('b3238e68', __exports__)
  }
  
  module.hot.accept("./navbar-list.vue?vue&type=template&id=b3238e68&scoped=true", () => {
    api.rerender('b3238e68', render)
  })

}


export default __exports__